import React from 'react';
import './CursorGlow.css';

export default function CursorGlow() {
  return <div className="cursor-glow" data-glow aria-hidden="true" />;
}
